import { Alert, Button, Input, Steps } from 'antd';
import React, { useState, useEffect } from 'react';
import Timer from 'react-compound-timer';
import { useDispatch, useSelector } from 'react-redux';
import { EDIT_PROFILE } from '../../../actions/types';
import { confirmationEmailService } from '../../../services/profile';
import { isValidEmail, openNotificationInToast } from '../../../utilities';
import ModalBox from '../../../components/common/ModalBox';

const timer = 30000;

function ChangeEmailModal(props) {
  const { isModalVisible, setIsModalVisible, currentStep, setCurrentStep, userDetails } = props;
  const authentications = useSelector((state) => state.authentications);
  const { editStatus, failedUsers } = useSelector((state) => state.profile);
  const { domainDetails } = useSelector((state) => state.listings);
  const [endTimer, setEndTimer] = useState(false);
  const [newEmail, setnewEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const dispatch = useDispatch();

  const { Step } = Steps;

  useEffect(() => {
    setEmailError('');
  }, []);

  const onChangeEmail = (data) => {
    setnewEmail(data);
    setEmailError('');
    if (userDetails.users.email === data) {
      setEmailError('The old and new email cannot be same!');
    }
  };

  const onBlur = () => {
    if (newEmail !== '' && !isValidEmail(newEmail)) {
      setEmailError('Please enter a valid email address!');
    } else {
      setEmailError('');
    }
  };

  const sendVerificationEmail = () => {
    if (!isValidEmail(newEmail)) {
      setEmailError('Please enter a valid email address!');
    } else {
      setEndTimer(false);
      getEndTimer();
      dispatch({
        type: EDIT_PROFILE,
        payload: {
          email: newEmail,
          isMicroSite: true,
          organizationId: domainDetails.id
        },
      });
      setEmailError('');
    }
  };
  const getEndTimer = () => {
    setTimeout(() => {
      setEndTimer(true);
    }, timer);
  };

  const handleDone = () => {
    setIsModalVisible(false);
    setCurrentStep(0);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  useEffect(() => {
    if (editStatus === 'failed' && failedUsers !== '') {
      setEmailError(`A user with this email ${newEmail} already exists. Please try with a different email!`);
    } else if (editStatus === 'success') {
      setCurrentStep(1);
    }
  }, [editStatus]);

  const goBack = () => {
    setCurrentStep(0);
  };

  const verifyEmail = () => {
    confirmationEmailService(newEmail, domainDetails.id)
      .then((response) => {
        openNotificationInToast('success', 'Success!', 'Email verification link has been sent to ' + newEmail);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // console.log('currentStep', currentStep);

  const step1 = (
    <div>
      <div className='changeModal_subHeader'>We will send a verification email to the new email address.</div>
      <div className='mt_10'>Current Email: {userDetails.users.email}</div>
      <div className='changeModal_inputMargin'>
        <Input addonBefore='New Email' size='large' value={newEmail} type='email' onChange={(ev) => onChangeEmail(ev.target.value)} onBlur={onBlur} />
      </div>
      {emailError ? <div className='error_text mt_5'>{emailError}</div> : null}
      <div className='changeModal_buttons'>
        <Button onClick={() => setIsModalVisible(false)} className='button_default'>
          Cancel
        </Button>
        <Button disabled={emailError !== '' || newEmail === '' ? true : false} onClick={sendVerificationEmail} type='primary'>
          Next
        </Button>
      </div>
    </div>
  );

  const step2 = (
    <div className='step2Container'>
      <p className='content_center'>
        We have sent you a verification email to <span className='bold_500'>{newEmail}</span>.
        <span onClick={() => goBack()} className='link_button pointer'>
          Change Email?
        </span>
      </p>
      <p className='content_center bodyContent'>Please check your email inbox and click on the Verify Email button to verify this email address.</p>
      <p className='content_center'>
        Didn’t receive verification email?{' '}
        {!endTimer ? (
          <span>
            Resend Email in{' '}
            <span className='link_button'>
              <Timer initialTime={timer} direction='backward'>
                <Timer.Seconds /> seconds
              </Timer>
            </span>
          </span>
        ) : (
          <span onClick={verifyEmail} className='link_button pointer'>
            Resend Email
          </span>
        )}
      </p>
      {authentications && authentications.loggedIn.status === 'BAD_REQUEST' ? <Alert message={authentications.loggedIn.message} type='warning' showIcon className='mt_20' /> : null}
      <Button onClick={handleDone} className='submitButton' type='primary'>
        Done
      </Button>
    </div>
  );

  return (
    <ModalBox title='Change Email' visible={isModalVisible} setVisible={setIsModalVisible} className='changeModal'>
      <Steps size='small' current={currentStep}>
        <Step title='Enter New Email' />
        <Step title='Verify Email' />
      </Steps>
      {currentStep === 0 ? step1 : step2}
    </ModalBox>
  );
}

export default ChangeEmailModal;
